module.exports = __webpack_public_path__ + "img/cptx3@2x.3a3e6713.png";